export default function alphanumerical(a, b) {
    a = a.text;
    b = b.text;

    return a.localeCompare(b);
}